import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { CoreResource } from '@mtna/pojo-consumer-ts';

/**
 * Determines if a resource exists in a list.
 * Length is the first argument so that the pipe will re-run anytime the list changes.
 *
 * @param id the identifier of the resource
 * @param resources the array of resources to check
 */
@Pipe({
  name: 'rdsCoreResourceExists',
})
export class RdsCoreResourceExistsPipe implements PipeTransform {
  transform(length: number | null | undefined, id: string | null | undefined, resources: Array<CoreResource>): boolean {
    if (!length || !id) {
      return false;
    }
    return length > 0 && resources.some((r) => r.uri === id || r.id === id);
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [RdsCoreResourceExistsPipe],
  declarations: [RdsCoreResourceExistsPipe],
})
export class RdsCoreResourceExistsPipeModule {}
